/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardSettingsRouteImport } from './routes/dashboard/settings'
import { Route as DashboardAuditIndexRouteImport } from './routes/dashboard/audit/index'
import { Route as DashboardEmailIndexRouteImport } from './routes/dashboard/email/index'
import { Route as DashboardLabsIndexRouteImport } from './routes/dashboard/labs/index'
import { Route as DashboardLabsLabIdRouteImport } from './routes/dashboard/labs/$labId'
import { Route as DashboardOrdersIndexRouteImport } from './routes/dashboard/orders/index'
import { Route as DashboardOrdersOrderIdRouteImport } from './routes/dashboard/orders/$orderId'
import { Route as DashboardPatientsIndexRouteImport } from './routes/dashboard/patients/index'
import { Route as DashboardPatientsPatientIdRouteImport } from './routes/dashboard/patients/$patientId'
import { Route as DashboardPaymentsIndexRouteImport } from './routes/dashboard/payments/index'
import { Route as DashboardPaymentsPaymentIdRouteImport } from './routes/dashboard/payments/$paymentId'
import { Route as DashboardProductsIndexRouteImport } from './routes/dashboard/products/index'
import { Route as DashboardProductsProductIdRouteImport } from './routes/dashboard/products/$productId'
import { Route as DashboardSettingsIndexRouteImport } from './routes/dashboard/settings/index'
import { Route as DashboardSettingsAccessControlRouteImport } from './routes/dashboard/settings/access-control'
import { Route as DashboardSettingsNotificationsRouteImport } from './routes/dashboard/settings/notifications'
import { Route as DashboardSettingsStaffNotificationsRouteImport } from './routes/dashboard/settings/staff-notifications'
import { Route as DashboardSupportIndexRouteImport } from './routes/dashboard/support/index'
import { Route as DashboardSettingsAccessControlIndexRouteImport } from './routes/dashboard/settings/access-control/index'
import { Route as DashboardSettingsAccessControlRolesAndPermsRouteImport } from './routes/dashboard/settings/access-control/roles-and-perms'
import { Route as DashboardSettingsGenHealthIndexRouteImport } from './routes/dashboard/settings/gen-health/index'
import { Route as DashboardSettingsLabAiIndexRouteImport } from './routes/dashboard/settings/lab-ai/index'
import { Route as DashboardSettingsRestrictedStatesIndexRouteImport } from './routes/dashboard/settings/restricted-states/index'
import { Route as DashboardSupportChatsIndexRouteImport } from './routes/dashboard/support/chats/index'
import { Route as DashboardSettingsAccessControlPortalUsersIndexRouteImport } from './routes/dashboard/settings/access-control/portal-users/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsRoute = DashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAuditIndexRoute = DashboardAuditIndexRouteImport.update({
  id: '/audit/',
  path: '/audit/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardEmailIndexRoute = DashboardEmailIndexRouteImport.update({
  id: '/email/',
  path: '/email/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardLabsIndexRoute = DashboardLabsIndexRouteImport.update({
  id: '/labs/',
  path: '/labs/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardLabsLabIdRoute = DashboardLabsLabIdRouteImport.update({
  id: '/labs/$labId',
  path: '/labs/$labId',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardOrdersIndexRoute = DashboardOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardOrdersOrderIdRoute = DashboardOrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardPatientsIndexRoute = DashboardPatientsIndexRouteImport.update({
  id: '/patients/',
  path: '/patients/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardPatientsPatientIdRoute =
  DashboardPatientsPatientIdRouteImport.update({
    id: '/patients/$patientId',
    path: '/patients/$patientId',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardPaymentsIndexRoute = DashboardPaymentsIndexRouteImport.update({
  id: '/payments/',
  path: '/payments/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardPaymentsPaymentIdRoute =
  DashboardPaymentsPaymentIdRouteImport.update({
    id: '/payments/$paymentId',
    path: '/payments/$paymentId',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardProductsIndexRoute = DashboardProductsIndexRouteImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardProductsProductIdRoute =
  DashboardProductsProductIdRouteImport.update({
    id: '/products/$productId',
    path: '/products/$productId',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardSettingsIndexRoute = DashboardSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardSettingsRoute,
} as any)
const DashboardSettingsAccessControlRoute =
  DashboardSettingsAccessControlRouteImport.update({
    id: '/access-control',
    path: '/access-control',
    getParentRoute: () => DashboardSettingsRoute,
  } as any)
const DashboardSettingsNotificationsRoute =
  DashboardSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => DashboardSettingsRoute,
  } as any)
const DashboardSettingsStaffNotificationsRoute =
  DashboardSettingsStaffNotificationsRouteImport.update({
    id: '/staff-notifications',
    path: '/staff-notifications',
    getParentRoute: () => DashboardSettingsRoute,
  } as any)
const DashboardSupportIndexRoute = DashboardSupportIndexRouteImport.update({
  id: '/support/',
  path: '/support/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSettingsAccessControlIndexRoute =
  DashboardSettingsAccessControlIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardSettingsAccessControlRoute,
  } as any)
const DashboardSettingsAccessControlRolesAndPermsRoute =
  DashboardSettingsAccessControlRolesAndPermsRouteImport.update({
    id: '/roles-and-perms',
    path: '/roles-and-perms',
    getParentRoute: () => DashboardSettingsAccessControlRoute,
  } as any)
const DashboardSettingsGenHealthIndexRoute =
  DashboardSettingsGenHealthIndexRouteImport.update({
    id: '/gen-health/',
    path: '/gen-health/',
    getParentRoute: () => DashboardSettingsRoute,
  } as any)
const DashboardSettingsLabAiIndexRoute =
  DashboardSettingsLabAiIndexRouteImport.update({
    id: '/lab-ai/',
    path: '/lab-ai/',
    getParentRoute: () => DashboardSettingsRoute,
  } as any)
const DashboardSettingsRestrictedStatesIndexRoute =
  DashboardSettingsRestrictedStatesIndexRouteImport.update({
    id: '/restricted-states/',
    path: '/restricted-states/',
    getParentRoute: () => DashboardSettingsRoute,
  } as any)
const DashboardSupportChatsIndexRoute =
  DashboardSupportChatsIndexRouteImport.update({
    id: '/support/chats/',
    path: '/support/chats/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardSettingsAccessControlPortalUsersIndexRoute =
  DashboardSettingsAccessControlPortalUsersIndexRouteImport.update({
    id: '/portal-users/',
    path: '/portal-users/',
    getParentRoute: () => DashboardSettingsAccessControlRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/dashboard/settings': typeof DashboardSettingsRouteWithChildren
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/labs/$labId': typeof DashboardLabsLabIdRoute
  '/dashboard/orders/$orderId': typeof DashboardOrdersOrderIdRoute
  '/dashboard/patients/$patientId': typeof DashboardPatientsPatientIdRoute
  '/dashboard/payments/$paymentId': typeof DashboardPaymentsPaymentIdRoute
  '/dashboard/products/$productId': typeof DashboardProductsProductIdRoute
  '/dashboard/settings/access-control': typeof DashboardSettingsAccessControlRouteWithChildren
  '/dashboard/settings/notifications': typeof DashboardSettingsNotificationsRoute
  '/dashboard/settings/staff-notifications': typeof DashboardSettingsStaffNotificationsRoute
  '/dashboard/audit/': typeof DashboardAuditIndexRoute
  '/dashboard/email/': typeof DashboardEmailIndexRoute
  '/dashboard/labs/': typeof DashboardLabsIndexRoute
  '/dashboard/orders/': typeof DashboardOrdersIndexRoute
  '/dashboard/patients/': typeof DashboardPatientsIndexRoute
  '/dashboard/payments/': typeof DashboardPaymentsIndexRoute
  '/dashboard/products/': typeof DashboardProductsIndexRoute
  '/dashboard/settings/': typeof DashboardSettingsIndexRoute
  '/dashboard/support/': typeof DashboardSupportIndexRoute
  '/dashboard/settings/access-control/roles-and-perms': typeof DashboardSettingsAccessControlRolesAndPermsRoute
  '/dashboard/settings/access-control/': typeof DashboardSettingsAccessControlIndexRoute
  '/dashboard/settings/gen-health/': typeof DashboardSettingsGenHealthIndexRoute
  '/dashboard/settings/lab-ai/': typeof DashboardSettingsLabAiIndexRoute
  '/dashboard/settings/restricted-states/': typeof DashboardSettingsRestrictedStatesIndexRoute
  '/dashboard/support/chats/': typeof DashboardSupportChatsIndexRoute
  '/dashboard/settings/access-control/portal-users/': typeof DashboardSettingsAccessControlPortalUsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/labs/$labId': typeof DashboardLabsLabIdRoute
  '/dashboard/orders/$orderId': typeof DashboardOrdersOrderIdRoute
  '/dashboard/patients/$patientId': typeof DashboardPatientsPatientIdRoute
  '/dashboard/payments/$paymentId': typeof DashboardPaymentsPaymentIdRoute
  '/dashboard/products/$productId': typeof DashboardProductsProductIdRoute
  '/dashboard/settings/notifications': typeof DashboardSettingsNotificationsRoute
  '/dashboard/settings/staff-notifications': typeof DashboardSettingsStaffNotificationsRoute
  '/dashboard/audit': typeof DashboardAuditIndexRoute
  '/dashboard/email': typeof DashboardEmailIndexRoute
  '/dashboard/labs': typeof DashboardLabsIndexRoute
  '/dashboard/orders': typeof DashboardOrdersIndexRoute
  '/dashboard/patients': typeof DashboardPatientsIndexRoute
  '/dashboard/payments': typeof DashboardPaymentsIndexRoute
  '/dashboard/products': typeof DashboardProductsIndexRoute
  '/dashboard/settings': typeof DashboardSettingsIndexRoute
  '/dashboard/support': typeof DashboardSupportIndexRoute
  '/dashboard/settings/access-control/roles-and-perms': typeof DashboardSettingsAccessControlRolesAndPermsRoute
  '/dashboard/settings/access-control': typeof DashboardSettingsAccessControlIndexRoute
  '/dashboard/settings/gen-health': typeof DashboardSettingsGenHealthIndexRoute
  '/dashboard/settings/lab-ai': typeof DashboardSettingsLabAiIndexRoute
  '/dashboard/settings/restricted-states': typeof DashboardSettingsRestrictedStatesIndexRoute
  '/dashboard/support/chats': typeof DashboardSupportChatsIndexRoute
  '/dashboard/settings/access-control/portal-users': typeof DashboardSettingsAccessControlPortalUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/dashboard/settings': typeof DashboardSettingsRouteWithChildren
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/labs/$labId': typeof DashboardLabsLabIdRoute
  '/dashboard/orders/$orderId': typeof DashboardOrdersOrderIdRoute
  '/dashboard/patients/$patientId': typeof DashboardPatientsPatientIdRoute
  '/dashboard/payments/$paymentId': typeof DashboardPaymentsPaymentIdRoute
  '/dashboard/products/$productId': typeof DashboardProductsProductIdRoute
  '/dashboard/settings/access-control': typeof DashboardSettingsAccessControlRouteWithChildren
  '/dashboard/settings/notifications': typeof DashboardSettingsNotificationsRoute
  '/dashboard/settings/staff-notifications': typeof DashboardSettingsStaffNotificationsRoute
  '/dashboard/audit/': typeof DashboardAuditIndexRoute
  '/dashboard/email/': typeof DashboardEmailIndexRoute
  '/dashboard/labs/': typeof DashboardLabsIndexRoute
  '/dashboard/orders/': typeof DashboardOrdersIndexRoute
  '/dashboard/patients/': typeof DashboardPatientsIndexRoute
  '/dashboard/payments/': typeof DashboardPaymentsIndexRoute
  '/dashboard/products/': typeof DashboardProductsIndexRoute
  '/dashboard/settings/': typeof DashboardSettingsIndexRoute
  '/dashboard/support/': typeof DashboardSupportIndexRoute
  '/dashboard/settings/access-control/roles-and-perms': typeof DashboardSettingsAccessControlRolesAndPermsRoute
  '/dashboard/settings/access-control/': typeof DashboardSettingsAccessControlIndexRoute
  '/dashboard/settings/gen-health/': typeof DashboardSettingsGenHealthIndexRoute
  '/dashboard/settings/lab-ai/': typeof DashboardSettingsLabAiIndexRoute
  '/dashboard/settings/restricted-states/': typeof DashboardSettingsRestrictedStatesIndexRoute
  '/dashboard/support/chats/': typeof DashboardSupportChatsIndexRoute
  '/dashboard/settings/access-control/portal-users/': typeof DashboardSettingsAccessControlPortalUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/dashboard/settings'
    | '/dashboard/'
    | '/dashboard/labs/$labId'
    | '/dashboard/orders/$orderId'
    | '/dashboard/patients/$patientId'
    | '/dashboard/payments/$paymentId'
    | '/dashboard/products/$productId'
    | '/dashboard/settings/access-control'
    | '/dashboard/settings/notifications'
    | '/dashboard/settings/staff-notifications'
    | '/dashboard/audit/'
    | '/dashboard/email/'
    | '/dashboard/labs/'
    | '/dashboard/orders/'
    | '/dashboard/patients/'
    | '/dashboard/payments/'
    | '/dashboard/products/'
    | '/dashboard/settings/'
    | '/dashboard/support/'
    | '/dashboard/settings/access-control/roles-and-perms'
    | '/dashboard/settings/access-control/'
    | '/dashboard/settings/gen-health/'
    | '/dashboard/settings/lab-ai/'
    | '/dashboard/settings/restricted-states/'
    | '/dashboard/support/chats/'
    | '/dashboard/settings/access-control/portal-users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dashboard'
    | '/dashboard/labs/$labId'
    | '/dashboard/orders/$orderId'
    | '/dashboard/patients/$patientId'
    | '/dashboard/payments/$paymentId'
    | '/dashboard/products/$productId'
    | '/dashboard/settings/notifications'
    | '/dashboard/settings/staff-notifications'
    | '/dashboard/audit'
    | '/dashboard/email'
    | '/dashboard/labs'
    | '/dashboard/orders'
    | '/dashboard/patients'
    | '/dashboard/payments'
    | '/dashboard/products'
    | '/dashboard/settings'
    | '/dashboard/support'
    | '/dashboard/settings/access-control/roles-and-perms'
    | '/dashboard/settings/access-control'
    | '/dashboard/settings/gen-health'
    | '/dashboard/settings/lab-ai'
    | '/dashboard/settings/restricted-states'
    | '/dashboard/support/chats'
    | '/dashboard/settings/access-control/portal-users'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/dashboard/settings'
    | '/dashboard/'
    | '/dashboard/labs/$labId'
    | '/dashboard/orders/$orderId'
    | '/dashboard/patients/$patientId'
    | '/dashboard/payments/$paymentId'
    | '/dashboard/products/$productId'
    | '/dashboard/settings/access-control'
    | '/dashboard/settings/notifications'
    | '/dashboard/settings/staff-notifications'
    | '/dashboard/audit/'
    | '/dashboard/email/'
    | '/dashboard/labs/'
    | '/dashboard/orders/'
    | '/dashboard/patients/'
    | '/dashboard/payments/'
    | '/dashboard/products/'
    | '/dashboard/settings/'
    | '/dashboard/support/'
    | '/dashboard/settings/access-control/roles-and-perms'
    | '/dashboard/settings/access-control/'
    | '/dashboard/settings/gen-health/'
    | '/dashboard/settings/lab-ai/'
    | '/dashboard/settings/restricted-states/'
    | '/dashboard/support/chats/'
    | '/dashboard/settings/access-control/portal-users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/settings': {
      id: '/dashboard/settings'
      path: '/settings'
      fullPath: '/dashboard/settings'
      preLoaderRoute: typeof DashboardSettingsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/audit/': {
      id: '/dashboard/audit/'
      path: '/audit'
      fullPath: '/dashboard/audit/'
      preLoaderRoute: typeof DashboardAuditIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/email/': {
      id: '/dashboard/email/'
      path: '/email'
      fullPath: '/dashboard/email/'
      preLoaderRoute: typeof DashboardEmailIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/labs/': {
      id: '/dashboard/labs/'
      path: '/labs'
      fullPath: '/dashboard/labs/'
      preLoaderRoute: typeof DashboardLabsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/labs/$labId': {
      id: '/dashboard/labs/$labId'
      path: '/labs/$labId'
      fullPath: '/dashboard/labs/$labId'
      preLoaderRoute: typeof DashboardLabsLabIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/orders/': {
      id: '/dashboard/orders/'
      path: '/orders'
      fullPath: '/dashboard/orders/'
      preLoaderRoute: typeof DashboardOrdersIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/orders/$orderId': {
      id: '/dashboard/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/dashboard/orders/$orderId'
      preLoaderRoute: typeof DashboardOrdersOrderIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/patients/': {
      id: '/dashboard/patients/'
      path: '/patients'
      fullPath: '/dashboard/patients/'
      preLoaderRoute: typeof DashboardPatientsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/patients/$patientId': {
      id: '/dashboard/patients/$patientId'
      path: '/patients/$patientId'
      fullPath: '/dashboard/patients/$patientId'
      preLoaderRoute: typeof DashboardPatientsPatientIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/payments/': {
      id: '/dashboard/payments/'
      path: '/payments'
      fullPath: '/dashboard/payments/'
      preLoaderRoute: typeof DashboardPaymentsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/payments/$paymentId': {
      id: '/dashboard/payments/$paymentId'
      path: '/payments/$paymentId'
      fullPath: '/dashboard/payments/$paymentId'
      preLoaderRoute: typeof DashboardPaymentsPaymentIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/products/': {
      id: '/dashboard/products/'
      path: '/products'
      fullPath: '/dashboard/products/'
      preLoaderRoute: typeof DashboardProductsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/products/$productId': {
      id: '/dashboard/products/$productId'
      path: '/products/$productId'
      fullPath: '/dashboard/products/$productId'
      preLoaderRoute: typeof DashboardProductsProductIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/settings/': {
      id: '/dashboard/settings/'
      path: '/'
      fullPath: '/dashboard/settings/'
      preLoaderRoute: typeof DashboardSettingsIndexRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/dashboard/settings/access-control': {
      id: '/dashboard/settings/access-control'
      path: '/access-control'
      fullPath: '/dashboard/settings/access-control'
      preLoaderRoute: typeof DashboardSettingsAccessControlRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/dashboard/settings/notifications': {
      id: '/dashboard/settings/notifications'
      path: '/notifications'
      fullPath: '/dashboard/settings/notifications'
      preLoaderRoute: typeof DashboardSettingsNotificationsRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/dashboard/settings/staff-notifications': {
      id: '/dashboard/settings/staff-notifications'
      path: '/staff-notifications'
      fullPath: '/dashboard/settings/staff-notifications'
      preLoaderRoute: typeof DashboardSettingsStaffNotificationsRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/dashboard/support/': {
      id: '/dashboard/support/'
      path: '/support'
      fullPath: '/dashboard/support/'
      preLoaderRoute: typeof DashboardSupportIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/settings/access-control/': {
      id: '/dashboard/settings/access-control/'
      path: '/'
      fullPath: '/dashboard/settings/access-control/'
      preLoaderRoute: typeof DashboardSettingsAccessControlIndexRouteImport
      parentRoute: typeof DashboardSettingsAccessControlRoute
    }
    '/dashboard/settings/access-control/roles-and-perms': {
      id: '/dashboard/settings/access-control/roles-and-perms'
      path: '/roles-and-perms'
      fullPath: '/dashboard/settings/access-control/roles-and-perms'
      preLoaderRoute: typeof DashboardSettingsAccessControlRolesAndPermsRouteImport
      parentRoute: typeof DashboardSettingsAccessControlRoute
    }
    '/dashboard/settings/gen-health/': {
      id: '/dashboard/settings/gen-health/'
      path: '/gen-health'
      fullPath: '/dashboard/settings/gen-health/'
      preLoaderRoute: typeof DashboardSettingsGenHealthIndexRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/dashboard/settings/lab-ai/': {
      id: '/dashboard/settings/lab-ai/'
      path: '/lab-ai'
      fullPath: '/dashboard/settings/lab-ai/'
      preLoaderRoute: typeof DashboardSettingsLabAiIndexRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/dashboard/settings/restricted-states/': {
      id: '/dashboard/settings/restricted-states/'
      path: '/restricted-states'
      fullPath: '/dashboard/settings/restricted-states/'
      preLoaderRoute: typeof DashboardSettingsRestrictedStatesIndexRouteImport
      parentRoute: typeof DashboardSettingsRoute
    }
    '/dashboard/support/chats/': {
      id: '/dashboard/support/chats/'
      path: '/support/chats'
      fullPath: '/dashboard/support/chats/'
      preLoaderRoute: typeof DashboardSupportChatsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/settings/access-control/portal-users/': {
      id: '/dashboard/settings/access-control/portal-users/'
      path: '/portal-users'
      fullPath: '/dashboard/settings/access-control/portal-users/'
      preLoaderRoute: typeof DashboardSettingsAccessControlPortalUsersIndexRouteImport
      parentRoute: typeof DashboardSettingsAccessControlRoute
    }
  }
}

interface DashboardSettingsAccessControlRouteChildren {
  DashboardSettingsAccessControlRolesAndPermsRoute: typeof DashboardSettingsAccessControlRolesAndPermsRoute
  DashboardSettingsAccessControlIndexRoute: typeof DashboardSettingsAccessControlIndexRoute
  DashboardSettingsAccessControlPortalUsersIndexRoute: typeof DashboardSettingsAccessControlPortalUsersIndexRoute
}

const DashboardSettingsAccessControlRouteChildren: DashboardSettingsAccessControlRouteChildren =
  {
    DashboardSettingsAccessControlRolesAndPermsRoute:
      DashboardSettingsAccessControlRolesAndPermsRoute,
    DashboardSettingsAccessControlIndexRoute:
      DashboardSettingsAccessControlIndexRoute,
    DashboardSettingsAccessControlPortalUsersIndexRoute:
      DashboardSettingsAccessControlPortalUsersIndexRoute,
  }

const DashboardSettingsAccessControlRouteWithChildren =
  DashboardSettingsAccessControlRoute._addFileChildren(
    DashboardSettingsAccessControlRouteChildren,
  )

interface DashboardSettingsRouteChildren {
  DashboardSettingsAccessControlRoute: typeof DashboardSettingsAccessControlRouteWithChildren
  DashboardSettingsNotificationsRoute: typeof DashboardSettingsNotificationsRoute
  DashboardSettingsStaffNotificationsRoute: typeof DashboardSettingsStaffNotificationsRoute
  DashboardSettingsIndexRoute: typeof DashboardSettingsIndexRoute
  DashboardSettingsGenHealthIndexRoute: typeof DashboardSettingsGenHealthIndexRoute
  DashboardSettingsLabAiIndexRoute: typeof DashboardSettingsLabAiIndexRoute
  DashboardSettingsRestrictedStatesIndexRoute: typeof DashboardSettingsRestrictedStatesIndexRoute
}

const DashboardSettingsRouteChildren: DashboardSettingsRouteChildren = {
  DashboardSettingsAccessControlRoute:
    DashboardSettingsAccessControlRouteWithChildren,
  DashboardSettingsNotificationsRoute: DashboardSettingsNotificationsRoute,
  DashboardSettingsStaffNotificationsRoute:
    DashboardSettingsStaffNotificationsRoute,
  DashboardSettingsIndexRoute: DashboardSettingsIndexRoute,
  DashboardSettingsGenHealthIndexRoute: DashboardSettingsGenHealthIndexRoute,
  DashboardSettingsLabAiIndexRoute: DashboardSettingsLabAiIndexRoute,
  DashboardSettingsRestrictedStatesIndexRoute:
    DashboardSettingsRestrictedStatesIndexRoute,
}

const DashboardSettingsRouteWithChildren =
  DashboardSettingsRoute._addFileChildren(DashboardSettingsRouteChildren)

interface DashboardRouteChildren {
  DashboardSettingsRoute: typeof DashboardSettingsRouteWithChildren
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardLabsLabIdRoute: typeof DashboardLabsLabIdRoute
  DashboardOrdersOrderIdRoute: typeof DashboardOrdersOrderIdRoute
  DashboardPatientsPatientIdRoute: typeof DashboardPatientsPatientIdRoute
  DashboardPaymentsPaymentIdRoute: typeof DashboardPaymentsPaymentIdRoute
  DashboardProductsProductIdRoute: typeof DashboardProductsProductIdRoute
  DashboardAuditIndexRoute: typeof DashboardAuditIndexRoute
  DashboardEmailIndexRoute: typeof DashboardEmailIndexRoute
  DashboardLabsIndexRoute: typeof DashboardLabsIndexRoute
  DashboardOrdersIndexRoute: typeof DashboardOrdersIndexRoute
  DashboardPatientsIndexRoute: typeof DashboardPatientsIndexRoute
  DashboardPaymentsIndexRoute: typeof DashboardPaymentsIndexRoute
  DashboardProductsIndexRoute: typeof DashboardProductsIndexRoute
  DashboardSupportIndexRoute: typeof DashboardSupportIndexRoute
  DashboardSupportChatsIndexRoute: typeof DashboardSupportChatsIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardSettingsRoute: DashboardSettingsRouteWithChildren,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardLabsLabIdRoute: DashboardLabsLabIdRoute,
  DashboardOrdersOrderIdRoute: DashboardOrdersOrderIdRoute,
  DashboardPatientsPatientIdRoute: DashboardPatientsPatientIdRoute,
  DashboardPaymentsPaymentIdRoute: DashboardPaymentsPaymentIdRoute,
  DashboardProductsProductIdRoute: DashboardProductsProductIdRoute,
  DashboardAuditIndexRoute: DashboardAuditIndexRoute,
  DashboardEmailIndexRoute: DashboardEmailIndexRoute,
  DashboardLabsIndexRoute: DashboardLabsIndexRoute,
  DashboardOrdersIndexRoute: DashboardOrdersIndexRoute,
  DashboardPatientsIndexRoute: DashboardPatientsIndexRoute,
  DashboardPaymentsIndexRoute: DashboardPaymentsIndexRoute,
  DashboardProductsIndexRoute: DashboardProductsIndexRoute,
  DashboardSupportIndexRoute: DashboardSupportIndexRoute,
  DashboardSupportChatsIndexRoute: DashboardSupportChatsIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
